import { render } from "./TheLogin.vue?vue&type=template&id=aa0aafca&scoped=true"
import script from "./TheLogin.vue?vue&type=script&lang=js"
export * from "./TheLogin.vue?vue&type=script&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=aa0aafca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0aafca"]])

export default __exports__